import { t } from "i18next"
import { localisedValue } from "utils"


const transformPolicyType = (response,callerComp) => {
  const transformedData = response.map(item => ({
    ...item,
    label: localisedValue({ object: item, key: "name" }),
    value: item?.id.toString(),
  }))
  if (callerComp=="policyForm"){
    return transformedData
  }
  else{
    const array=[ { id: 0, key: "all", name: t("All") },...transformedData]
    return array
  }
 
}
export default transformPolicyType
